import React from 'react';
import styled from 'styled-components';
import renderRichText from '../utils/render-rich-text';
import { GatsbyImage } from 'gatsby-plugin-image';

/**
 * Component that renders Image with Floating Text
 *
 * @component ImageWithFloatingTextTemplate
 * 
 * @param {object} props
 * 
 * @prop {string} imageAlignment
 * @prop {object} image
 * @prop {string} richText
 * @prop {string} alt 
 * 
 * @return {JSX}
 */

const ImageWithFloatingTextTemplate = props => {
  const { imageAlignment, image, richText, alt, onClickHandler, geoSpace } = props;

  return (
    <div>
      {image && (
        <div onClick={onClickHandler ? () => onClickHandler() : null}>
          <ImageWithFloatingText image={image} imageAlignment={imageAlignment.toLowerCase()} alt={alt} />
        </div>
      )}
      {renderRichText(richText, geoSpace)}
    </div>
  );
};

const ImageWithFloatingText = styled(GatsbyImage)`
  cursor: zoom-in;
  max-width: 50%;
  float: ${({ imageAlignment }) => {
    return imageAlignment;
  }};
  margin-bottom: 0px;
  ${({ imageAlignment }) => {
    return imageAlignment === 'right' ? 'margin-left: 20px' : 'margin-right: 20px';
  }};

  @media screen and (max-width: 400px) {
    max-width: 90%;
    margin: 10px;
    float: none;
  }
`;

export default ImageWithFloatingTextTemplate;
